export default function getImageAssetURL(name: string, cdn: boolean = true) {
  const cdnUrl = import.meta.env.VITE_CDN_BASE_URL;

  if (!cdn) {
    return `/assets/images/${name}`;
  }

  return `${cdnUrl}/${name}`;
}
